import React from "react";
import "./styles.css";

export const Loading = () => {
  return (
    <div class="lds-ripple">
      <div></div>
      <div></div>
    </div>
  );
};
